module.exports = __webpack_public_path__ + "static/photo4-28d62a0f8ec380973da3a6c8f458d0da.png";